/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import '../../../../../../App.css'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import 'react-datepicker/dist/react-datepicker.css'
import DatePicker from 'react-datepicker'
import {toast} from 'react-toastify'
import useApi from '../../../../../../hooks/useQuery'
import useMutationApi from '../../../../../../hooks/useMutation'
import {success} from '../../../../../../data/Status/success'
import {ToastMessageContainer} from '../../../../../../_ePulse/layout/components/ToastMessageContainer'
import {EDIT_PATIENT, GET_PATIENT_BY_ID} from '../../../GraphQLQueries/Patients'
import {
  calculateAgeFromDOB,
  calculateDateFromInput,
  calculateDOB,
  checkMobileNoValid,
  checkzipcodeValid,
} from '../../../../../../data/config'
import {checkPermission} from '../../../../../App'
import {LoadingSpinner} from '../../../../../../_ePulse/layout/components/LoadingSpinner'
import moment from 'moment'
import {GET_BLOOD_GROUP_LIST} from '../../../../../common/GraphQLQuries/common'

const Schema = Yup.object().shape({
  firstName: Yup.string().required('First name is required'),
  lastName: Yup.string().required('Last name is required'),
  countryCode: Yup.string().required('Country is required').not(['default'], 'Select Country Code'),
  // mobileNumber: Yup.number().required('Mobile number is required'),
})

type initialValuesTypes = {
  firstName: string | null
  lastName: string | null
  gender: string | null
  bloodGroup: string | null
  dob: Date | null
  // email: '',
  zipCode: number | string
  street: string | null
  city: string | null
  district: string | null
  state: string | null
  country: string | null
  countryCode: string | null
  mobileNumber: string | null
  isUserRegistered: boolean | null
  // isPdfPrinted: true,
}

const initialValues: initialValuesTypes = {
  firstName: '',
  lastName: '',
  gender: '',
  bloodGroup: '',
  dob: null,
  // email: '',
  zipCode: '',
  street: '',
  city: '',
  district: '',
  state: '',
  country: '',
  countryCode: '',
  mobileNumber: '',
  isUserRegistered: false,
  // isPdfPrinted: true,
}

export function EditTodayPatientModal(props: any) {
  const [bloodGroupList, setBloodGroupList] = useState<any>([])
  const {
    data: data6,
    loading: loading6,
    error: error6,
    refetch: refectch6,
  } = useApi(true, GET_PATIENT_BY_ID, {
    id: props.idToEdit,
  })

  const {
    data: bloodGrooupData,
    loading: loading1,
    error: error2,
    refetch: refetch2,
  } = useApi(true, GET_BLOOD_GROUP_LIST, {})

  useEffect(() => {
    if (bloodGrooupData) {
      const res = bloodGrooupData?.getBloodGroupList

      setBloodGroupList(res)
    }
    // refectch6()
  }, [bloodGrooupData])

  useEffect(() => {
    if (data6) {
      const res = data6?.getBusinessUserProfile
      formik.setValues({
        ...formik.values,
        firstName: res?.userProfile?.firstName || '',
        lastName: res?.userProfile?.lastName || '',
        gender: res?.userProfile?.gender || 'default',
        dob: res?.userProfile?.dob ? new Date(res?.userProfile?.dob) : null,
        bloodGroup: res?.userProfile?.bloodGroup,
        // email: res?.userProfile?.email || '',
        zipCode: res?.userAddress?.zipCode || '',
        street: res?.userAddress?.street || '',
        city: res?.userAddress?.city || '',
        district: res?.userAddress?.district || '',
        state: res?.userAddress?.state || '',
        country: res?.userAddress?.country || '',
        countryCode: res?.countryCode || 'default',
        mobileNumber: res?.mobileNumber ? res?.mobileNumber : undefined,
        isUserRegistered: res?.isUserRegistered,
      })
      if (res?.userProfile?.dob) {
        const {years, months, days} = calculateAgeFromDOB(new Date(res?.userProfile?.dob))
        setYears(years)
        setMonths(months)
        setDays(days)
      }
    }
  }, [data6])

  const {createData, loading, error, data} = useMutationApi(EDIT_PATIENT)

  const [isloading, setLoading] = useState(false)
  const [ageUnit, setAgeUnit] = useState('year')
  const [ageError, setAgeError] = useState<string | null>()
  const [ageValue, setAgeValue] = useState<any>()
  const [years, setYears] = useState<any>()
  const [months, setMonths] = useState<any>()
  const [days, setDays] = useState<any>()

  // const handleAgeChange = (value: any) => {
  //   validate(value, ageUnit)
  // }

  const handleAgeChange = (year: any, month: any, day: any) => {
    const dob = calculateDOB(year, month, day)
    formik.setFieldValue('dob', dob)
  }

  const validate = (val: any, type: string) => {
    console.log('val', val, type)
    if (val === '') {
      setAgeError('')
      setAgeValue('')
      console.log('val is empty')
      return
    }

    const num = Number(val)
    if (isNaN(num)) {
      setAgeError('Invalid number')
      console.log('val is not a number')
      return
    }

    if (type === 'year' && num <= 0) {
      setAgeError('Year must be greater than 0')
      console.log('year is less than 0')
    } else if (type === 'month' && (num < 1 || num > 12)) {
      console.log('month is less than 1 or greater than 12')
      setAgeError('Month must be between 1 and 12')
    } else if (type === 'day' && (num < 1 || num > 31)) {
      console.log('day is less than 1 or greater than 31')
      setAgeError('Day must be between 1 and 31')
    } else {
      setAgeValue(val)
      const date = calculateDateFromInput(type, val)
      console.log('date', moment(date).format('YYYY-MM-DD'), date)
      formik.setFieldValue('dob', date)
      setAgeError('')
    }
  }

  const editCategoryCallAPI = async (values: any) => {
    try {
      const res = await createData({
        userRoleId: props?.idToEdit,
        firstName: values?.firstName,
        lastName: values?.lastName,
        gender: values?.gender === 'default' ? undefined : values?.gender,
        dob: values.dob ? moment(values.dob).format('YYYY-MM-DD') : undefined,
        bloodGroup: values.bloodGroup ? values?.bloodGroup : undefined,
        countryCode: values?.countryCode,
        mobileNumber: values?.mobileNumber,
        zipCode: values?.zipCode ? JSON.stringify(values?.zipCode) : undefined,
        // address: values?.street,
        city: values?.city === '' ? undefined : values?.city,
        district: values?.district === '' ? undefined : values?.district,
        state: values?.state === '' ? undefined : values?.state,
        country: values?.country === 'default' ? undefined : values?.country,
      })

      toast.success(success.PATIENT_UPDATED)
      // setTimeout(() => {
      props.closeModal(false)
      // }, 1000)
      setLoading(false)
    } catch (error: any) {
      console.log('ERROR......', error)
      setLoading(false)
    }
  }

  const formik = useFormik({
    initialValues,
    validationSchema: Schema,
    onSubmit: async (values) => {
      setLoading(true)
      try {
        editCategoryCallAPI(values)
        setLoading(false)
      } catch (error) {
        setLoading(false)
      }
    },
  })

  const changeMobileNo = (value: any) => {
    // const number = value
    // if (/^\d*$/.test(number) && number.length <= 10) {
    //   formik.setFieldValue('mobileNumber', parseInt(value))
    // }
    const valid = checkMobileNoValid(value)
    if (valid) {
      formik.setFieldValue('mobileNumber', parseInt(value))
    }
  }

  const changezipcode = (value: any) => {
    // const number = value
    // if (/^\d*$/.test(number) && number.length <= 10) {
    //   formik.setFieldValue('mobileNumber', parseInt(value))
    // }
    const valid = checkzipcodeValid(value)
    if (valid) {
      formik.setFieldValue('zipCode', parseInt(value))
    }
  }

  return (
    <div>
      <ToastMessageContainer />
      <Modal
        show={props.modalState}
        dialogClassName='ePulse-modal ePulse-modal-70w'
        onHide={() => props.closeModal(false)}
        backdrop='static'
      >
        <Modal.Header className='border-0' closeButton>
          <span className='fs-3 fw-bold'>Edit Patient</span>
        </Modal.Header>
        <Modal.Body className='container' />
        <div className='ePulse-modal-content'>
          <LoadingSpinner isLoading={loading || loading6} />
          <form onSubmit={formik.handleSubmit}>
            <div className='d-flex flex-column justify-content-between mb-4'>
              <div className='d-flex flex-row'>
                <div className='col form-block'>
                  <span className='form-label required'>First Name</span>
                  <input
                    disabled={formik.values.isUserRegistered === false ? false : true}
                    type={'text'}
                    className='form-control px-3 '
                    {...formik.getFieldProps('firstName')}
                  />
                  {formik.touched.firstName && formik.errors.firstName && (
                    <div className='fv-plugins-message-container'>
                      <span className='text-danger'>{formik.errors.firstName}</span>
                    </div>
                  )}
                </div>
                <div className='col form-block'>
                  <span className='form-label required'>Last Name</span>
                  <input
                    disabled={formik.values.isUserRegistered === false ? false : true}
                    type={'text'}
                    className='form-control px-3 '
                    {...formik.getFieldProps('lastName')}
                  />
                  {formik.touched.lastName && formik.errors.lastName && (
                    <div className='fv-plugins-message-container'>
                      <span className='text-danger'>{formik.errors.lastName}</span>
                    </div>
                  )}
                </div>
              </div>

              <div className='d-flex flex-row'>
                <div className='d-flex flex-row col-lg-6 mb-3 form-block'>
                  <span className='fs-5 mb-2 col-5'>Country Code:</span>
                  <span className='fs-5 fw-bold mb-2 col'>{formik.values.countryCode}</span>
                </div>
                <div className='d-flex flex-row col-lg-6 mb-3 form-block'>
                  <span className='fs-5 mb-2 col-5'>Mobile Number:</span>
                  <span className='fs-5 fw-bold mb-2 col'>
                    {formik.values.mobileNumber || 'NA'}
                  </span>
                </div>
              </div>
              {/* <div className='d-flex flex-row'>
                <div className='d-flex flex-row col-lg-6 mb-3 form-block'>
                  <span className='fs-5 mb-2 col-5'>Street:</span>
                  <span className='fs-5 fw-bold mb-2 col'>{formik.values.street}</span>
                </div>
                <div className='d-flex flex-row col-lg-6 mb-3 form-block'>
                  <span className='fs-5 mb-2 col-5'>City:</span>
                  <span className='fs-5 fw-bold mb-2 col'>{formik.values.city}</span>
                </div>
              </div> */}

              <div className='d-flex flex-row'>
                <div className='col form-block'>
                  <span className='form-label '>Street</span>
                  <input
                    disabled={formik.values.isUserRegistered === false ? false : true}
                    type={'text'}
                    className='form-control px-3 '
                    {...formik.getFieldProps('street')}
                  />
                  {formik.touched.street && formik.errors.street && (
                    <div className='fv-plugins-message-container'>
                      <span className='text-danger'>{formik.errors.street}</span>
                    </div>
                  )}
                </div>
                <div className='col form-block'>
                  <span className='form-label '>City</span>
                  <input
                    disabled={formik.values.isUserRegistered === false ? false : true}
                    type={'text'}
                    className='form-control px-3 '
                    {...formik.getFieldProps('city')}
                  />
                  {formik.touched.city && formik.errors.city && (
                    <div className='fv-plugins-message-container'>
                      <span className='text-danger'>{formik.errors.city}</span>
                    </div>
                  )}
                </div>
              </div>

              <div className='d-flex flex-row'>
                <div className='col form-block'>
                  <span className='form-label '>District</span>
                  <input
                    disabled={formik.values.isUserRegistered === false ? false : true}
                    type={'text'}
                    className='form-control px-3 '
                    {...formik.getFieldProps('district')}
                  />
                  {formik.touched.district && formik.errors.district && (
                    <div className='fv-plugins-message-container'>
                      <span className='text-danger'>{formik.errors.district}</span>
                    </div>
                  )}
                </div>
                <div className='col form-block'>
                  <span className='form-label '>Zip Code</span>
                  <input
                    type={'number'}
                    disabled={formik.values.isUserRegistered === false ? false : true}
                    onWheel={(e) => {
                      e.preventDefault() // Prevent mouse wheel and touchpad scrolling
                    }}
                    // Disable scrolling when focused
                    onFocus={(e) => e.target.addEventListener('wheel', (e) => e.preventDefault())}
                    className='form-control px-3 '
                    value={formik.values.zipCode}
                    onChange={(e: any) => changezipcode(e.target.value)}
                  />
                  {formik.touched.zipCode && formik.errors.zipCode && (
                    <div className='fv-plugins-message-container'>
                      <span className='text-danger'>{formik.errors.zipCode}</span>
                    </div>
                  )}
                </div>
              </div>
              {/* <div className='d-flex flex-row'>
                <div className='d-flex flex-row col-lg-6 mb-3 form-block'>
                  <span className='fs-5 mb-2 col-5'>District:</span>
                  <span className='fs-5 fw-bold mb-2 col'>{formik.values.district}</span>
                </div>
                <div className='d-flex flex-row col-lg-6 mb-3 form-block'>
                  <span className='fs-5 mb-2 col-5'>Zip Code:</span>
                  <span className='fs-5 fw-bold mb-2 col'>{formik.values.zipCode}</span>
                </div>
              </div> */}

              <div className='d-flex flex-row'>
                <div className='col form-block'>
                  <span className='form-label '>State</span>
                  <input
                    disabled={formik.values.isUserRegistered === false ? false : true}
                    type={'text'}
                    className='form-control px-3 '
                    {...formik.getFieldProps('state')}
                  />
                  {formik.touched.state && formik.errors.state && (
                    <div className='fv-plugins-message-container'>
                      <span className='text-danger'>{formik.errors.state}</span>
                    </div>
                  )}
                </div>
                <div className='col form-block'>
                  <span className='form-label '>Country</span>
                  <input
                    disabled={formik.values.isUserRegistered === false ? false : true}
                    type={'text'}
                    className='form-control px-3 '
                    {...formik.getFieldProps('country')}
                  />
                  {formik.touched.country && formik.errors.country && (
                    <div className='fv-plugins-message-container'>
                      <span className='text-danger'>{formik.errors.country}</span>
                    </div>
                  )}
                </div>
              </div>
              {/* <div className='d-flex flex-row'>
                <div className='d-flex flex-row col-lg-6 mb-3 form-block'>
                  <span className='fs-5 mb-2 col-5'>State:</span>
                  <span className='fs-5 fw-bold mb-2 col'>{formik.values.state}</span>
                </div>
                <div className='d-flex flex-row col-lg-6 mb-3 form-block'>
                  <span className='fs-5 mb-2 col-5'>Country:</span>
                  <span className='fs-5 fw-bold mb-2 col'>{formik.values.country}</span>
                </div>
              </div> */}
              <div className='row'>
                <div className='col form-block'>
                  <span className='form-label'>Blood Group:</span>
                  {/* <input
                    type={'text'}
                    className='form-control px-3 '
                    {...formik.getFieldProps('bloodGroup')}
                  /> */}
                  <select className='form-control' {...formik.getFieldProps('bloodGroup')}>
                    <option key={'default'} value={''} disabled>
                      Select Blood Group
                    </option>
                    {bloodGroupList.map((bloodGroup: any, index: number) => {
                      return (
                        <option key={index} value={bloodGroup.bloodGroupName}>
                          {bloodGroup.bloodGroupName}
                        </option>
                      )
                    })}
                    )
                  </select>
                  {formik.touched.bloodGroup && formik.errors.bloodGroup && (
                    <div className='fv-plugins-message-container'>
                      <span className='text-danger'>{formik.errors.bloodGroup}</span>
                    </div>
                  )}
                </div>
                <div className='col form-block '>
                  <span className='form-label '>Gender</span>
                  <select className='form-control' {...formik.getFieldProps('gender')}>
                    <option key={'default'} value={'default'}>
                      Select Gender
                    </option>
                    <option key={'Male'} value={'Male'}>
                      Male
                    </option>
                    <option key={'Female'} value={'Female'}>
                      Female
                    </option>
                    <option key={'Other'} value={'Other'}>
                      Other
                    </option>
                    )
                  </select>
                  {formik.touched.gender && formik.errors.gender && (
                    <div className='fv-plugins-message-container'>
                      <span className='text-danger'>{formik.errors.gender}</span>
                    </div>
                  )}
                </div>
              </div>

              <div className='row'>
                <div className='col form-block'>
                  <span className='form-label'>Date of Birth</span>
                  {/* <input
                    type={'text'}
                    className='form-control px-3 '
                    {...formik.getFieldProps('lastName')}
                  /> */}
                  <DatePicker
                    placeholderText='Select Date of Birth'
                    className='form-control'
                    selected={formik.values.dob}
                    dateFormat={'dd/MM/yyyy'}
                    onChange={(e: Date) => {
                      formik.setFieldValue('dob', e)
                      if (e !== null) {
                        const {years, months, days} = calculateAgeFromDOB(e)
                        setYears(years)
                        setMonths(months)
                        setDays(days)
                      } else {
                        setYears('')
                        setMonths('')
                        setDays('')
                      }
                    }}
                    maxDate={new Date()}
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode='scroll'
                  />
                  {/* {formik.touched.dob && formik.errors.dob && (
                    <div className='fv-plugins-message-container'>
                      <span className='text-danger'>{formik.errors.dob}</span>
                    </div>
                  )} */}
                </div>
                <div className='col form-block'>
                  <span className='form-label'>Enter Age</span>

                  <div className='d-flex flex-row custom-age-wrapper'>
                    <input
                      type='number'
                      placeholder={`Enter Age in year`}
                      className='form-control px-3 '
                      value={years}
                      onChange={(e) => {
                        setYears(e.target.value)
                        handleAgeChange(e.target.value, months, days)
                      }}
                    />
                    <div className='verticalSeperator' />
                    <input
                      type='number'
                      placeholder={`Enter Age in month`}
                      className='form-control px-3 '
                      value={months}
                      onChange={(e) => {
                        setMonths(e.target.value)
                        handleAgeChange(years, e.target.value, days)
                      }}
                    />
                    <div className='verticalSeperator' />
                    <input
                      type='number'
                      placeholder={`Enter Age in days`}
                      className='form-control px-3 '
                      value={days}
                      onChange={(e) => {
                        setDays(e.target.value)
                        handleAgeChange(years, months, e.target.value)
                      }}
                    />
                  </div>

                  {/* <div className='d-flex flex-row custom-age-wrapper'>
                    <select
                      className=''
                      value={ageUnit}
                      onChange={(e) => {
                        setAgeUnit(e.target.value)
                        validate(ageValue, e.target.value)
                      }}
                    >
                      <option key={'year'} value={'year'}>
                        Year(s)
                      </option>
                      <option key={'month'} value={'month'}>
                        Month(s)
                      </option>
                      <option key={'day'} value={'day'}>
                        Day(s)
                      </option>
                      )
                    </select>
                    <div className='verticalSeperator' />
                    <input
                      type='number'
                      placeholder={`Enter Age in ${ageUnit}`}
                      className='form-control px-3 '
                      value={ageValue}
                      onChange={(e) => handleAgeChange(e.target.value)}
                    />
                  </div> */}
                </div>
                {/* <div className='col form-block'>
                  <span className='form-label '>Email</span>
                  <input
                    disabled
                    type={'text'}
                    className='form-control px-3 '
                    {...formik.getFieldProps('email')}
                  />
                  {formik.touched.email && formik.errors.email && (
                    <div className='fv-plugins-message-container'>
                      <span className='text-danger'>{formik.errors.email}</span>
                    </div>
                  )}
                </div> */}
              </div>
            </div>
            {checkPermission('editBusinessPatient') && (
              <div className='btn-row'>
                <button className='ePulse-btn-primary' type='submit'>
                  {!isloading && 'Update'}
                  {isloading && (
                    <span className='indicator-progress' style={{display: 'block'}}>
                      Please wait...{' '}
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  )}
                </button>
              </div>
            )}
          </form>
        </div>
      </Modal>
    </div>
  )
}
